import { ApiClient } from './client/api_client';

class AccountProfile {
  static async update(profileId: string, body: any) {
    return await ApiClient.put(`/v1/account/profile/${profileId}`, body);
  }
}

export { AccountProfile };
